import createCachedSelector from "re-reselect";

import type { ResultsReduxState } from "@app/types/results-redux-types";

import { getTrips } from "../state-accessors";
import { getJourneyIdOfLongestTripFromLegCardId } from "./get-journey-id-of-longest-trip-from-leg-card-id";
import { getLegCardById } from "./get-leg-card-by-id";

export const getTripIdsByLegCardIdAndJourneyId = createCachedSelector(
  getTrips,
  getLegCardById,
  getJourneyIdOfLongestTripFromLegCardId,
  (
    _: ResultsReduxState,
    _leg_card_id,
    journey_id?: string | null | undefined
  ) => journey_id,
  (trips, trip_ids = [], journey_id_of_longest_trip, journey_id) => {
    const trip_ids_by_journey_id = trip_ids.reduce(
      (acc, trip_id) => {
        // @ts-expect-error TS2339 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
        const { journey_id } = trips[trip_id];

        if (acc[journey_id]) {
          acc[journey_id].push(trip_id);
        } else {
          acc[journey_id] = [trip_id];
        }
        return acc;
      },
      {} as Record<string, string[]>
    );

    // return list of trips ids that have the same destination
    return (
      trip_ids_by_journey_id[journey_id ?? journey_id_of_longest_trip] ??
      trip_ids_by_journey_id[journey_id_of_longest_trip]
    );
  }
)((_, leg_card_id, journey_id) => leg_card_id + journey_id);
